import Vue from 'vue'
import Router from 'vue-router'
import axios from 'axios';
import apiUrl from '../constants';


// Containers
import Full from '@/containers/Full'

// Views
import dashboard from '@/views/components/dashboard'
import admindashboard from '@/views/components/admindashboard'
import Charts from '@/views/Charts'
import Widgets from '@/views/Widgets'

// Views - Components
import Buttons from '@/views/components/Buttons'
import SocialButtons from '@/views/components/SocialButtons'
import Cards from '@/views/components/Cards'
import Forms from '@/views/components/Forms'
import Modals from '@/views/components/Modals'
import Switches from '@/views/components/Switches'
import Tables from '@/views/components/Tables'
import test from '@/views/test'
import Role from '@/views/components/role'
import AppRole from '@/views/components/approle'
import Permissions from '@/views/components/permissions'
import Apppermissions from '@/views/components/apppermissions'
import Appmodules from '@/views/components/appmodules'
import Merchant from '@/views/components/merchant'
import User from '@/views/components/user'
import Systemusers from '@/views/components/systemusers'
import projectmaster from '@/views/components/projectmaster'
import Pagination from '@/views/components/pagination'
import supplierMaster from '@/views/components/supplierMaster'
import UserType from '@/views/components/usertype'
import Appuserprojectroles from '@/views/components/appUserProjectRoles'
import Subdepartment from '@/views/components/subdepartment'
import businessvertical from '@/views/components/businessvertical'
import buissnesssubvertical from '@/views/components/buissnesssubvertical'
import userdesignation from '@/views/components/userdesignation'
import hrflag from '@/views/components/hrflag'
import verticalType from '@/views/components/verticaltype'
import verticalfunction from '@/views/components/verticalfunction'
import designationMapping from '@/views/components/designationMapping'

// Views - Icons
import FontAwesome from '@/views/icons/FontAwesome'
import SimpleLineIcons from '@/views/icons/SimpleLineIcons'
import CryptoJS from 'crypto-js';

// Views - Pages
import Page404 from '@/views/pages/Page404'
import Page500 from '@/views/pages/Page500'
import Login from '@/views/components/login'
import ForgotPassword from '@/views/components/forgotpassword'
import ResetPassword from '@/views/components/resetpassword'
import Verifymobileno from '@/views/components/verifymobileno'
import Register from '@/views/components/register'
import changepassword from '@/views/components/changepassword'
import Designation from '@/views/components/designation'
import Department from '@/views/components/department'
import EmployeeType from '@/views/components/employeetype'
import EmployeeCategory from '@/views/components/employeecategory'
import AccessProjects from '@/views/components/accessprojects'
import ProjectRoleAccessView from '@/views/components/projectroleaccessview'
import userdetails from '@/views/components/userdetails'
import hubuseraccess from '@/views/components/hubuseraccess'
import userclientmap from '@/views/components/userclientmap'
import iptracking from '@/views/components/iptracking'
import userdetailtableview from '@/views/components/userdetailtableview'
import festivalSupport from '@/views/components/festivalSupport'
import forcelogout from '@/views/components/forcelogout'
import maintenance from '@/views/components/maintenance'
import Mappinguserhub from '@/views/components/mappinguserhub'
import SystemProjectRoleAccessView from '@/views/components/systemprojectroleaccessview'
import Mappingusersubdepartment from '@/views/components/mappingusersubdepartment'
import Stockistshipmenthub from '@/views/components/StockistShipmentHub'
import exportcsv from '@/views/components/exportcsv'
import SRRedisDetailsView from '@/views/components/SRRedisDetailsView'
import multipleSRUserDetails from '@/views/components/multipleSRUserDetails'
import changeapplicationpassword from '@/views/components/changeapplicationpassword'
import verifyuserotp from '@/views/components/verifyuserotp'
import userstatuslist from '@/views/components/userstatuslist'
import userrestrictionlist from '@/views/components/userrestrictionlist'
import resetpasswordwith2fa from '@/views/components/resetpasswordwith2fa'
import otpverificationforresetpass from '@/views/components/otpverificationforresetpass'

Vue.use(Router)
const router = new Router({
	mode: 'hash', // Demo is living in GitHub.io, so required!
	linkActiveClass: 'open active',
	scrollBehavior: () => ({
		y: 0
	}),
	routes: [{
			path: '/',
			redirect: '/admindashboard',
			name: 'Home',
			component: Full,
			children: [
				{
					path: 'dashboard',
					name: 'dashboard',
					component: dashboard,
					meta: {
						requiresAuth: true,
						adminAuth: true,
						breadcrumb: [
							{
								name: 'User Access Dashboard'
							}
						]
					},
				},
				{
					path: 'pagination',
					name: 'Pagination',
					component: Pagination,
					meta: {
						requiresAuth: true,
						breadcrumb: [{
								name: 'Home',
								link: '/admindashboard'
							},
							{
								name: 'Pagination'
							}
						]
					}
				},
				{
					path: '/admindashboard',
					name: 'admindashboard',
					component: admindashboard,
					meta: {
						requiresAuth: true,
						adminAuth: true,
						breadcrumb: [
							{
								name: 'Admin Dashboard'
							}
						]
					}
				},
				{
					path: '/user',
					name: 'user',
					component: User,
					meta: {
						requiresAuth: true,
						adminAuth: true,
						breadcrumb: [{
								name: 'Home',
								link: '/admindashboard'
							},
							{
								name: 'Application Users'
							}
						]
					}
				},
				{
					path: '/accessprojects/:id?',
					name: 'accessprojects',
					component: AccessProjects,
					meta: {
						requiresAuth: true,
						adminAuth: true,
						breadcrumb: [{
								name: 'Home',
								link: '/admindashboard'
							},
							{
									name: 'Application Users',
									link: '/user'
							},
							{
								name: 'Application Access'
							}
						]
					}
				},
				{
					path: '/register/:id?',
					name: 'register',
					component: Register,
					meta: {
						requiresAuth: true,
						breadcrumb: [{
								name: 'Home',
								link: '/admindashboard'
							},
							{
									name: 'Application Users',
									link: '/user'
							},
							{
								name: 'User Registration'
							}
						]
					}
				},
				{
					path: '/usertype',
					name: 'usertype',
					component: UserType,
					meta: {
						requiresAuth: true,
						adminAuth: true,
						breadcrumb: [{
								name: 'Home',
								link: '/admindashboard'
							},
							{
								name: 'User Types'
							}
						]
					}
				},
				{
					path: '/userdetails',
					name: 'userdetails',
					component: userdetails,
					meta: {
						requiresAuth: true,
						adminAuth: true,
						breadcrumb: [{
								name: 'Home',
								link: '/userdetails'
							},
							{
								name: 'User Details'
							}
						]
					}
				},
				{
					path: '/hubuseraccess',
					name: 'hubuseraccess',
					component: hubuseraccess,
					meta: {
						requiresAuth: true,
						adminAuth: true,
						breadcrumb: [{
								name: 'Home',
								link: '/admindashboard'
							},
							{
								name: 'Hub Access Users'
							}
						]
					}
				},
				{
					path: '/exportcsv',
					name: 'exportcsv',
					component: exportcsv,
					meta: {
						requiresAuth: true,
						adminAuth: true,
						breadcrumb: [{
								name: 'Home',
								link: '/admindashboard'
							},
							{
								name: 'exportcsv'
							}
						]
					}
				},
				{
					path: '/userclientmap/:id?',
					name: 'userclientmap',
					component: userclientmap,
					meta: {
						requiresAuth: true,
						adminAuth: true,
						breadcrumb: [{
								name: 'Home',
								link: '/admindashboard'
							},
							{
									name: 'Application Users',
									link: '/user'
							},
							{
								name: 'User Client Map'
							}
						]
					}
				},
				{
					path: '/iptracking',
					name: 'iptracking',
					component: iptracking,
					meta: {
						requiresAuth: true,
						adminAuth: true,
						breadcrumb: [{
								name: 'Home',
								link: '/admindashboard'
							},
							{
								name: 'IP Tracking'
							}
						]
					}
				},
				{
					path: '/userdetailtableview',
					name: 'userdetailtableview',
					component: userdetailtableview,
					meta: {
						requiresAuth: true,
						adminAuth: true,
						breadcrumb: [{
								name: 'Home',
								link: '/admindashboard'
							},
							{
								name: 'User Detail Table View'
							}
						]
					}
				},
				{
					path: '/festivalSupport',
					name: 'festivalSupport',
					component: festivalSupport,
					meta: {
						requiresAuth: true,
						adminAuth: true,
						breadcrumb: [{
								name: 'Home',
								link: '/admindashboard'
							},
							{
								name: 'Central Master Support'
							}
						]
					}
				},
				{
					path: '/department',
					name: 'department',
					component: Department,
					meta: {
						requiresAuth: true,
						adminAuth: true,
						breadcrumb: [{
								name: 'Home',
								link: '/admindashboard'
							},
							{
								name: 'Department'
							}
						]
					}
				},
				{
					path: '/employeetype',
					name: 'employeetype',
					component: EmployeeType,
					meta: {
						requiresAuth: true,
						adminAuth: true,
						breadcrumb: [{
								name: 'Home',
								link: '/admindashboard'
							},
							{
								name: 'Employee Type'
							}
						]
					}
				},
				{
					path: '/employeecategory',
					name: 'employeecategory',
					component: EmployeeCategory,
					meta: {
						requiresAuth: true,
						adminAuth: true,
						breadcrumb: [{
								name: 'Home',
								link: '/admindashboard'
							},
							{
								name: 'Employee Category'
							}
						]
					}
				},
				{
					path: '/designation',
					name: 'designation',
					component: Designation,
					meta: {
						requiresAuth: true,
						adminAuth: true,
						breadcrumb: [{
								name: 'Home',
								link: '/admindashboard'
							},
							{
								name: 'Designation'
							}
						]
					}
				},
				{
					path: '/subdepartment',
					name: 'subdepartment',
					component: Subdepartment,
					meta: {
						requiresAuth: true,
						adminAuth: true,
						breadcrumb: [{
								name: 'Home',
								link: '/admindashboard'
							},
							{
								name: 'Subdepartment'
							}
						]
					}
				},
				{
					path: '/changepassword',
					name: 'changepassword',
					component: changepassword,
					meta: {
						requiresAuth: true,
						adminAuth: true,
						breadcrumb: [
							{
								name: 'Change Password'
							}
						]
					}
				},
				{
					path: '/role',
					name: 'role',
					component: Role,
					meta: {
						requiresAuth: true,
						adminAuth: true,
						breadcrumb: [{
								name: 'Home',
								link: '/admindashboard'
							},
							{
								name: 'System Roles'
							}
						]
					}
				},
				{
					path: '/approle',
					name: 'approle',
					component: AppRole,
					meta: {
						requiresAuth: true,
						adminAuth: true,
						breadcrumb: [{
								name: 'Home',
								link: '/admindashboard'
							},
							{
								name: 'Application Roles'
							}
						]
					}
				},
				{
					path: '/getallrediskeys',
					name: 'getallrediskeys',
					component: SRRedisDetailsView,
					meta: {
						requiresAuth: true,
						adminAuth: true,
						breadcrumb: [{
								name: 'Home',
								link: '/admindashboard'
							},
							{
								name: 'Verified SR User Details'
							}
						]
					}
				},
				{
					path: '/getMultipleSRUsers',
					name: 'getMultipleSRUsers',
					component: multipleSRUserDetails,
					meta: {
						requiresAuth: true,
						adminAuth: true,
						breadcrumb: [{
								name: 'Home',
								link: '/admindashboard'
							},
							{
								name: 'Verified Multiple SR Users'
							}
						]
					}
				},
				{
					path: '/projectmaster',
					name: 'projectmaster',
					component: projectmaster,
					meta: {
						requiresAuth: true,
						adminAuth: true,
						breadcrumb: [{
								name: 'Home',
								link: '/admindashboard'
							},
							{
								name: 'Projects'
							}
						]
					}
				},
				{
					path: '/permissions',
					name: 'permissions',
					component: Permissions,
					meta: {
						requiresAuth: true,
						adminAuth: true,
						breadcrumb: [{
								name: 'Home',
								link: '/admindashboard'
							},
							{
								name: 'System Permissions'
							}
						]
					}
				},
				{
					path: '/apppermissions',
					name: 'apppermissions',
					component: Apppermissions,
					meta: {
						requiresAuth: true,
						adminAuth: true,
						breadcrumb: [{
								name: 'Home',
								link: '/admindashboard'
							},
							{
								name: 'Application Modules'
							}
						]
					}
				},
				{
					path: '/appmodules/:id?',
					name: 'appmodules',
					component: Appmodules,
					meta: {
						requiresAuth: true,
						breadcrumb: [{
								name: 'Home',
								link: '/admindashboard'
							},
							{
									name: 'Application Modules',
									link: '/apppermissions'
							},
							{
								name: 'Module Pages'
							}
						]
					}
				},
				{
					path: '/systemusers',
					name: 'systemusers',
					component: Systemusers,
					meta: {
						requiresAuth: true,
						adminAuth: true,
						breadcrumb: [{
								name: 'Home',
								link: '/admindashboard'
							},
							{
								name: 'System Users'
							}
						]
					}
				},
				{
					path: '/appuserprojectroles/:id?',
					name: 'appuserprojectroles',
					component: Appuserprojectroles,
					meta: {
						requiresAuth: true,
						//adminAuth: true,
						breadcrumb: [{
								name: 'Home',
								link: '/admindashboard'
							},
							{
									name: 'Application Users',
									link: '/user'
							},
							{
								name: 'Override Module Access'
							}
						]
					}
				},
				{
					path: '/projectroleaccessview',
					name: 'projectroleaccessview',
					component: ProjectRoleAccessView,
					meta: {
						requiresAuth: true,
						adminAuth: true,
						breadcrumb: [{
								name: 'Home',
								link: '/admindashboard'
							},
							{
								name: 'Access Page View'
							}
						]
					}
				},
				{
					path: '/systemprojectroleaccessview',
					name: 'systemprojectroleaccessview',
					component: SystemProjectRoleAccessView,
					meta: {
					  requiresAuth: true,
					  adminAuth: true,
					  breadcrumb: [{
						  name: 'Home',
						  link: '/admindashboard'
						},
						{
						  name: 'Access Page View'
						}
					  ]
					}
				  },
				{
					path: '/maphubsusers/:id?',
					name: 'maphubsusers',
					component: Mappinguserhub,
					meta: {
						requiresAuth: true,
						adminAuth: true,
						breadcrumb: [{
								name: 'Home',
								link: '/admindashboard'
							},
							{
									name: 'Application Users',
									link: '/user'
							},
							{
								name: 'User hub mapping'
							}
						]
					}
				},
				{
					path: '/accesssubdepartment/:id?',
					name: 'accesssubdepartment',
					component: Mappingusersubdepartment,
					meta: {
						requiresAuth: true,
						adminAuth: true,
						breadcrumb: [{
								name: 'Home',
								link: '/admindashboard'
							},
							{
									name: 'Application Users',
									link: '/user'
							},
							{
								name: 'User Subdepartment mapping'
							}
						]
					}
				},
				{
					path: 'charts',
					name: 'Charts',
					component: Charts
				},
				{
					path: 'widgets',
					name: 'Widgets',
					component: Widgets
				},
				{
					path:'stockistshipmenthub',
					name: 'stockistshipmenthub',
					component: Stockistshipmenthub,
					meta: {
						requiresAuth: true
					}
				},

				{
					path: 'icons',
					redirect: '/icons/font-awesome',
					name: 'Icons',
					component: {
						render(c) {
							return c('router-view')
						}
					},
					children: [{
							path: 'font-awesome',
							name: 'Font Awesome',
							component: FontAwesome
						},
						{
							path: 'simple-line-icons',
							name: 'Simple Line Icons',
							component: SimpleLineIcons
						}
					]
				},
				{
					path: '/userstatuslist',
					name: 'userstatuslist',
					component: userstatuslist,
					meta: {
						requiresAuth: true,
						adminAuth: true,
						breadcrumb: [{
								name: 'Home',
								link: '/admindashboard'
							},
							{
								name: 'User Status'
							}
						]
					}
				},
				{
					path: '/userrestrictionlist',
					name: 'userrestrictionlist',
					component: userrestrictionlist,
					meta: {
						requiresAuth: true,
						adminAuth: true,
						breadcrumb: [{
								name: 'Home',
								link: '/admindashboard'
							},
							{
								name: 'User Restriction'
							}
						]
					}
				},
				{
					path: '/businessvertical',
					name: 'businessvertical',
					component: businessvertical,
					meta: {
						requiresAuth: true,
						adminAuth: true,
						breadcrumb: [{
								name: 'Home',
								link: '/admindashboard'
							},
							{
								name: 'Buissness Vertical'
							}
						]
					}
				},
					
				{
					path: '/buissnesssubvertical',
					name: 'buissnesssubvertical',
					component: buissnesssubvertical,
					meta: {
						requiresAuth: true,
						adminAuth: true,
						breadcrumb: [{
								name: 'Home',
								link: '/admindashboard'
							},
							{
								name: 'Buissness Sub Vertical'
							}
						]
					}
				},
				{
					path: '/userdesignation',
					name: 'userdesignation',
					component: userdesignation,
					meta: {
						requiresAuth: true,
						adminAuth: true,
						breadcrumb: [{
								name: 'Home',
								link: '/admindashboard'
							},
							{
								name: 'User Designation'
							}
						]
					}
				},
				{
					path: '/hrflag',
					name: 'hrflag',
					component: hrflag,
					meta: {
						requiresAuth: true,
						adminAuth: true,
						breadcrumb: [{
								name: 'Home',
								link: '/admindashboard'
							},
							{
								name: 'HR Flag'
							}
						]
					}
				},
				{
					path: '/verticalfunction',
					name: 'verticalfunction',
					component: verticalfunction,
					meta: {
						requiresAuth: true,
						adminAuth: true,
						breadcrumb: [{
								name: 'Home',
								link: '/admindashboard'
							},
							{
								name: 'Vertical Function'
							}
						]
					}
				},
				{
					path: '/verticalType',
					name: 'verticalType',
					component: verticalType,
					meta: {
						requiresAuth: true,
						adminAuth: true,
						breadcrumb: [{
								name: 'Home',
								link: '/admindashboard'
							},
							{
								name: 'Vertical Type'
							}
						]
					}
				},
				{
					path: '/designationMapping',
					name: 'designationMapping',
					component: designationMapping,
					meta: {
						requiresAuth: true,
						adminAuth: true,
						breadcrumb: [{
								name: 'Home',
								link: '/admindashboard'
							},
							{
								name: 'Designation Mapping'
							}
						]
					}
				}
			]
		},

		{
			path: '/login',
			name: 'login',
			component: Login
		},
		{
			path: '/resetpasswordwith2fa',
			name: 'resetpasswordwith2fa',
			component: resetpasswordwith2fa
		},
		{
			path: '/forgotpassword',
			name: 'forgotpassword',
			component: ForgotPassword
		},
		{
			path: '/forcelogout',
			name: 'forcelogout',
			component: forcelogout
		},
		{
			path: '/resetpassword/:token',
			name: 'resetpassword',
			component: ResetPassword
		},
		{
			path: '/verifymobileno/:token',
			name: 'verifymobileno',
			component: Verifymobileno
		},
		{
			path: '/maintenance',
			name: 'maintenance',
			component: maintenance
		},
		{
			path: '/pages',
			redirect: '/pages/p404',
			name: 'Pages',
			component: {
				render(c) {
					return c('router-view')
				}
			},
			children: [{
					path: '404',
					name: 'Page404',
					component: Page404
				},
				{
					path: '500',
					name: 'Page500',
					component: Page500
				},
				{
					path: 'login',
					name: 'Login',
					component: Login
				}
			]
		},
		{
			path: '/changeapplicationpassword/:token',
			name: 'changeapplicationpassword',
			component: changeapplicationpassword
		},
		{
			path: '/verifyuserotp/:token',
			name: 'verifyuserotp',
			component: verifyuserotp
		},
		{
			path: '/otpverificationforresetpass/:token',
			name: 'otpverificationforresetpass',
			component: otpverificationforresetpass
		}
	]
});

router.beforeEach((to, from, next) => {

	var isLoggedIn = window.localStorage.getItem('isLoggedIn');
	if (isLoggedIn == null) {
		isLoggedIn = false;
	} else {
		isLoggedIn = true;
	}

  if (isLoggedIn == true) {
    let unauthorizeVal=false;
      let userToken = window.localStorage.getItem('userToken')
      let myStr = null;
      if(userToken!= null){
         myStr = userToken.replace(/"/g, '');
      }
        axios({
            method: 'POST',
            'url': apiUrl.api_url + 'appvalidatetoken',
            'data': {},
            headers: {
              'Authorization': 'Bearer '+myStr
            }
         })
         .then((response) => {
					 /*--maintenance page call start--*/
					 if(response && response.data.ReturnCode=='104')
					 {
						 next({
						 	path: "/maintenance"
						 });
					 }
					 /*--maintenance page call end--*/
          },(error)=>{
            if(error.response.status===401){
              var userdetailEncrypt = window.localStorage.getItem('userdetail')
              var bytes  = CryptoJS.AES.decrypt(userdetailEncrypt.toString(), 'Key');
              var plaintext = bytes.toString(CryptoJS.enc.Utf8);
              var userdetail =JSON.parse(plaintext);
              this.userid = userdetail.userid;
              this.input = {
                userid: this.userid
              };
              unauthorizeVal = true;
              axios({
                method: "POST",
                url: apiUrl.api_url + "centralisedLoggedOut",
                data: this.input
                }).then((response) => {
                  localStorage.removeItem('permissiondata')
                  localStorage.removeItem('userToken')
                  localStorage.removeItem('isLoggedIn')
                  localStorage.removeItem('userdetail')
                  localStorage.removeItem('encryPassword')
                  localStorage.removeItem('AuthResponse')
                  localStorage.removeItem('IDtoken')
                  localStorage.removeItem('profile')
                  localStorage.removeItem('userToken')
                    next({
                      path: "/login",
                    });
                });
            }
        });

  }

	if (to.matched.some(record => record.meta.requiresAuth) && !isLoggedIn) {
		next({
			path: "/login",
		});
	} else {
		if (to.matched.some(record => record.meta.requiresAuth)) {
			const permissionEncrypt = window.localStorage.getItem('permissiondata')
			const bytes = CryptoJS.AES.decrypt(permissionEncrypt.toString(), 'Key');
			const plaintext = bytes.toString(CryptoJS.enc.Utf8);
			const permissiondata = JSON.parse(plaintext);
			function isBigEnough(findURL) {
				if(findURL.submenu.length>0){
					return findURL.submenu.some(isBigChildEnough);
				}
				return findURL.url == to.name;
			}
			function isBigChildEnough(findURL) {
				if(findURL.url != to.name){
					return findURL.submenu.some(isBigChildEnough);
				}
				return findURL.url == to.name;
			}
			const setroles = permissiondata.some(isBigEnough)
			if (setroles) {
				next();
			} else {
				next({
					path: "/dashboard",
				});
			}
		} else {
			next();
		}
	}

});
export default router;



// WEBPACK FOOTER //
// ./src/router/index.js